import { assertArray, assertTrue, assertString } from "../../app/utils/assert";
import { nameof } from "../../app/utils/nameof";
import { runAction } from "../client";
import { Key } from "../../models";

export interface SensorsDataRequest
{
    Ids: (string|number)[];
    TimeRange: string;
}

export interface SensorsDataIncidentRequest
{
	IncidentId: number;
}

export interface SensorsDataResult
{
	Rows: Row[];
	RefId: string;
	Axes: Axis[];
	Gapik: string;
}

export type DotType = 'circle' | 'square';
export interface Row
{
	DotType: DotType;
	Readings: Reading[];
	Baseline?: number;
	Title: string;
    id: number;
	
	UnitName?: string;

	// calculated on the client
	order: number;
}

export interface Axis
{
	RangeMin: number;
	RangeMax: number;
	SensorIds: Key[];	
}

export type Severity = 'red' | 'yellow';
export interface Reading
{
	DateTime: string;
	ReceivedOn: string;
	Value: number;

	Latitude?: number;
	Longitude?: number;
	UnixTimestamp?: number;

	POI: Severity;
	Severity: Severity;

	// generated on client
	date?: Date;
	dateTimeReceivedOn?: Date;
}

export interface GetSensorsDataFn
{
    (ids: Key[], timeRange: string): Promise<SensorsDataResult>
}

export interface GetSensorIncidentDataFn
{
    (incidentId: Key): Promise<SensorsDataResult>
}

export interface GetSensorsDataFn
{
	(ids: Key[], timeRange: string): Promise<SensorsDataResult>;
}

export interface GetSensorsDataForIncidentFn
{
	(incidentId: Key): Promise<SensorsDataResult>;
}

export const getSensorsData: GetSensorsDataFn = (ids: Key[], timeRange: string): Promise<SensorsDataResult> => {
	assertArray(ids, 'expected array of ids');
	assertTrue(timeRange != null && timeRange !== '', `${nameof({ timeRange })} has to be a non empty string`);

	const payload: SensorsDataRequest = {
		Ids: ids,
		TimeRange: timeRange,
	};

	localStorage.setItem('sensorDataFilter', JSON.stringify(payload));

	return runAction<SensorsDataResult>('/action/GetSensorsData', payload);
}

export const getSensorsDataForIncident: GetSensorsDataForIncidentFn = (incidentId: number): Promise<SensorsDataResult> => {
	assertString(incidentId, `${nameof({ incidentId })} has to be a string`);
	
	const payload: SensorsDataIncidentRequest = {
		IncidentId: incidentId,
	};

	return runAction<SensorsDataResult>('/action/GetSensorsData', payload);
}


// WEBPACK FOOTER //
// ./src/rest/Geotab/sensors_data.ts